import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyTechInsightsTab } from '../../../-components/CompanyTechInsightsTab';
import { companyFootprintQueryOptions } from '../../../-hooks/useCompanyTechInsights';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/tech-insights/',
)({
  // Started, not awaited: the footprint is a few hundred bounded counts and
  // takes seconds, so waiting for it would hold the tab switch. The tab opens
  // on its loading state and fills in from the same cache entry. A failure is
  // left to the component's own query, which surfaces it inline.
  loader: ({ params }) => {
    void queryClient
      .ensureQueryData(companyFootprintQueryOptions(params.companyId))
      .catch(() => undefined);
  },
  component: CompanyTechInsightsPage,
});

function CompanyTechInsightsPage() {
  const { companyId } = Route.useParams();
  return <CompanyTechInsightsTab companyId={companyId} />;
}
